import { FC } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';
import { FormData } from '../constants';

type Props = {
	formWatch: FormData;
	control: Control<FormData>;
	setValue: UseFormSetValue<FormData>;
};

const DayOfWeekInput: FC<Props> = ({ formWatch, control, setValue }) => {
	return (
		<>
			{formWatch.recurrenceType === 'WEEKLY' ? (
				<Box>
					<Controller
						name="dayOfWeek"
						control={control}
						render={() => (
							<FormControl fullWidth>
								<InputLabel id="day-of-week-label">Day of Week</InputLabel>
								<Select
									labelId="day-of-week-label"
									id="day-of-week"
									value={formWatch.dayOfWeek}
									label="Day of Week"
									onChange={(evt) =>
										setValue('dayOfWeek', evt.target.value, { shouldValidate: true })
									}
									sx={{ marginBottom: '1rem' }}
								>
									<MenuItem value={'Monday'}>Monday</MenuItem>
									<MenuItem value={'Tuesday'}>Tuesday</MenuItem>
									<MenuItem value={'Wednesday'}>Wednesday</MenuItem>
									<MenuItem value={'Thursday'}>Thursday</MenuItem>
									<MenuItem value={'Friday'}>Friday</MenuItem>
									<MenuItem value={'Saturday'}>Saturday</MenuItem>
									<MenuItem value={'Sunday'}>Sunday</MenuItem>
								</Select>
							</FormControl>
						)}
					/>
				</Box>
			) : (
				''
			)}
		</>
	);
};

export default DayOfWeekInput;
